module.exports = __webpack_public_path__ + "img/imgZXGH(21).3b0afbe8.png";